module.exports = __webpack_public_path__ + "img/section-title5.e52edf87.png";